import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=699c3f98"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports